export { default } from "./Scores";
